import React, { useEffect, useRef } from "react";
import { Wrapper, CustomisedTitle, CPButton, FlexColumn, Img } from "../../constants/common/StyledGlobalConstants";
import { Title, Body } from "@vds/typography";
import verizon_logo from "../../assets/images/RedballVerizonConnect.svg";
import { COMMON_CONSTANTS } from "../../constants/StringConstants";
import { useTranslation } from "react-i18next";
import PropTypes from "prop-types";

const RedBallFallbackPage = ({ windowSize, pageTitle, pageContent, buttonId, buttonHandler, buttonName }) => {
  const { t } = useTranslation("loginTranslation");
  const titleRef = useRef(null);
  useEffect(() => {
    document.title = `${t(COMMON_CONSTANTS.CUSTOMER_PORTAL)} - ${pageTitle}`;
  }, [pageTitle]);
  useEffect(() => {
    if (titleRef.current) {
          titleRef.current.focus();
          window.scrollTo(0, 0);
    }
  }, [titleRef.current]);
  return (
      <Wrapper
        display="flex"
        flexDirection="column"
        justifyContent={windowSize <= 679 ? "center" : ""}
        alignItems="center"
        height="100vh"
        marginLeft="1rem"
        marginRight="1rem"
      >
        <FlexColumn paddingTop={windowSize <= 679 ? "" : "6.8rem"} justifyContent="space-between">
          <Img
            height="43.3px"
            width="120px"
            aria-hidden="true"
            tabIndex="-1"
            alt="Verizon Connect, GPS Fleet Tracking System"
            src={verizon_logo}
            style={{ marginBottom: "40px" }}
          />
          <Wrapper width={windowSize <= 480 ? "100%" : "440px"}>
            <h1 className="sr-only" ref={titleRef} aria-live="assertive" tabIndex="-1">
              {pageTitle}
            </h1>
            <CustomisedTitle fontSize={"40px"} lineHeight="48px" aria-hidden="true" tabIndex="-1">
              <Title id="page-title" size="large" >
                {pageTitle}
              </Title>
            </CustomisedTitle>
            <Wrapper marginTop={"16px"} marginBottom={"40px"} width="100%">
              <Body size="small" id="page-content">
                {pageContent}
              </Body>
            </Wrapper>
            <CPButton
              boxButton={true}
              secondary
              height={"3rem"}
              type="submit"
              onClick={() => buttonHandler()}
              tabIndex={0}
              aria-label={buttonName}
            >
              {buttonName}
            </CPButton>
          </Wrapper>
        </FlexColumn>
      </Wrapper>
  );
};

RedBallFallbackPage.defaultProps = {
  buttonHandler: () => { },
  buttonName: "",
  buttonId: "",
  pageContent: "",
  pageTitle: "",
  windowSize: 0,
};

RedBallFallbackPage.propTypes = {
  windowSize: PropTypes.number,
  pageTitle: PropTypes.string,
  pageContent: PropTypes.node,
  buttonId: PropTypes.string,
  buttonHandler: PropTypes.func,
  buttonName: PropTypes.string,
};

export default RedBallFallbackPage;